/*
Author: Vinod
Date: 04/03//2020
Issue Description: On logging in after session time out, it's redirecting to the same page, with no data.
search_string: PL_2828
*/

/*
Author: Vinod
Date: 05/03//2020
Issue Description: Need to remove the red flash from Signin screen after session timeout.
search_string: PL_2904
*/


<template>
  <div class="modal">
    <div class="modal-content">
      <div class="header">
        <label class="paylief-is-Idle">Paylief is Idle</label>
      </div>
      <div class="body">
        <label class="auto-Logout-in">Auto Logout in</label>
        <div class="display-flex">
          <div class="clock">
            <div class="digit tenmin Flip-Top timersNumberStyle">
              <!--  -->
              <span class="base"></span>
              <div class="flap over front"></div>
              <div class="flap over back"></div>
              <div class="flap under"></div>
              <div class="Flip-Bottom"></div>
            </div>
            <div class="digit min Flip-Top timersNumberStyle">
              <!--  -->
              <span class="base"></span>
              <div class="flap over front"></div>
              <div class="flap over back"></div>
              <div class="flap under"></div>
              <div class="Flip-Bottom"></div>
            </div>
            <div class="digit tensec Flip-Top timersNumberStyle">
              <div>
                <span class="base"></span>
                <div class="flap over front"></div>
                <div class="flap over back"></div>
                <div class="flap under"></div>
              </div>
              <div class="Flip-Bottom"></div>
            </div>
            <div class="digit sec Flip-Top timersNumberStyle">
              <div>
                <span class="base"></span>
                <div class="flap over front"></div>
                <div class="flap over back"></div>
                <div class="flap under"></div>
              </div>
              <div class="Flip-Bottom"></div>
            </div>
          </div>
          <!-- / Commented for future reference as its a previous implementation / -->
          <!-- <div class="padding-5">
            <div class="Flip-Top">
              <p class="timersNumberStyle">{{timerCountObj.minutesOnesPlace}}</p>
            </div>
            <div class="Flip-Bottom"></div>
          </div>
          <div class="padding-20">
            <div class="Flip-Top">
              <p class="timersNumberStyle">{{timerCountObj.minutesTensPlace}}</p>
            </div>
            <div class="Flip-Bottom"></div>
          </div>
          <div class="padding-5">
            <div class="Flip-Top">
              <p class="timersNumberStyle">{{timerCountObj.secondsOnesPlace}}</p>
            </div>
            <div class="Flip-Bottom"></div>
          </div>
          <div>
            <div class="Flip-Top">
              <p class="timersNumberStyle">{{timerCountObj.secondsTensPlace}}</p>
            </div>
            <div class="Flip-Bottom"></div>
          </div>-->
        </div>

        <div class="bottom-text">
          <label class="mins-text">MINS</label>
          <label class="secs-text">SECS</label>
        </div>
        <!-- / Commented for future reference as its a previous implementation / -->
        <!-- <div class="container">
              <div class="nums nums-ten">
                  <div class="num" v-for="(data,i) of numsAray" :key="i" :data-num="i" :data-num-next="(i + 1 >= 10) ? 0 : i + 1">
                  </div>
              </div>
               <label>Min</label>
              <div class="nums nums-one">
                  <div class="num" v-for="(data,index) of numsAray" :key="index" :data-num="index" :data-num-next="(index + 1 >= 10) ? 0 : index + 1">
                  </div>
              </div>
               <label>Sec</label>
        </div>-->
      </div>
      <div class="footer">
        <img class="imgClass" src="@/assets/warning_error.svg" />&nbsp;
        <label class="all-Unsaved-Informat">All unsaved information will be lost</label>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import $ from "jquery";

export default {
  name: "IdleState",
  components: {},
  data() {
    return {
      timerCountObj: {
        minutesOnesPlace: 0,
        minutesTensPlace: 5,
        secondsOnesPlace: 0,
        secondsTensPlace: 0
      },
      numsAray: [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
      time: 300,
      errmsg: "",
      currentValue: null,
      timeLeft: 180,
      interval: null
    };
  },
  created() {
    /* Commented for future reference as its a previous implementation */
    this.setTime(false);
    let timerId = setInterval(() => {
      this.time -= 1;
      let minutes = Math.floor(this.time / 60);
      let seconds = Math.floor(this.time % 60);
      this.setTime(true, minutes, seconds);
      if (seconds < 10) {
        this.timeLeft = minutes + ":" + "0" + seconds;
      } else {
        this.timeLeft = minutes + ":" + seconds;
      }
      if (!this.$store.state.idleVue.isIdle) {
        this.time = 300;
        clearInterval(timerId);
      }
      if (this.time < 1) {
        clearInterval(timerId);
        this.confirmSignout();
      }
    }, 1000);
  },
  activated() {
    // setTime(false);
    // setInterval(function() {
    //   setTime(true);
    // }, 1000);
    //this.setTimer();
  },

  mounted() {
    //this.setTimer();
  },
  methods: {
    ...mapActions({
      act_signOut: "auth/signOut"
    }),
    async confirmSignout() {
      try {
        let res = await this.act_signOut();
        // As there is no response coming from server after logout so i am checking with header response status code
        this.$emit("onSignOut", false); // PL_2904
        if (res.status == 200) {
          // Start PL_2828
          this.$router.push({
            path: "/signin",
            query: { entry_url: this.$router.currentRoute.path }
          });
          // End PL_2828
          window.localStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("heartBeat")
          window.location.reload()

        }
      } catch (err) {
        // As we don't have any error page currently, i am leaving this by assigning the error to a variable
        this.errmsg = err;
      }
    },

    async setTimer() {
      let timerId = setInterval(() => {
        this.time -= 1;
        let minutes = Math.floor(this.time / 60);
        let seconds = Math.floor(this.time % 60);

        if (minutes < 10) {
          this.timerCountObj.minutesOnesPlace = "0";
          this.timerCountObj.minutesTensPlace = minutes.toString();
        } else {
          this.timerCountObj.minutesOnesPlace = minutes.toString()[0];
          this.timerCountObj.minutesTensPlace = minutes.toString()[1];
        }

        if (seconds < 10) {
          this.timerCountObj.secondsOnesPlace = "0";
          this.timerCountObj.secondsTensPlace = seconds.toString();
        } else {
          this.timerCountObj.secondsOnesPlace = seconds.toString()[0];
          this.timerCountObj.secondsTensPlace = seconds.toString()[1];
        }

        if (!this.$store.state.idleVue.isIdle) {
          this.time = 300;
          clearInterval(timerId);
        }

        if (minutes) {
          let onesDigit = minutes % 10;
        }

        if (this.time < 1) {
          clearInterval(timerId);
          this.confirmSignout();
        }
      }, 1000);
    },

    flipTo(digit, n) {
      var current = digit.attr("data-num");
      digit.attr("data-num", n);
      digit.find(".front").attr("data-content", current);
      digit.find(".back, .under").attr("data-content", n);
      digit.find(".flap").css("display", "block");
      setTimeout(function() {
        digit.find(".base").text(n);
        digit.find(".flap").css("display", "none");
      }, 350);
    },

    jumpTo(digit, n) {
      digit.attr("data-num", n);
      digit.find(".base").text(n);
    },

    updateGroup(group, n, flip) {
      var digit1 = $(".ten" + group);
      var digit2 = $("." + group);
      n = String(n);
      if (n.length == 1) n = "0" + n;
      var num1 = n.substr(0, 1);
      var num2 = n.substr(1, 1);
      if (digit1.attr("data-num") != num1) {
        if (flip) this.flipTo(digit1, num1);
        else this.jumpTo(digit1, num1);
      }
      if (digit2.attr("data-num") != num2) {
        if (flip) this.flipTo(digit2, num2);
        else this.jumpTo(digit2, num2);
      }
    },

    setTime(flip, min, sec) {
      this.updateGroup("min", min, flip);
      this.updateGroup("sec", sec, flip);
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1; /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;
  -webkit-animation-fill-mode: forwards; /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1) */
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 2s;
  -moz-animation-duration: 2s;
  animation-duration: 2s;
}

.fade-in.one {
  -webkit-animation-delay: 0.5s;
  -moz-animation-delay: 0.5s;
  animation-delay: 0.3s;
  transition: all 1.3s;
  background-position: 100% center;
}

.one {
  width: 208px;
  height: 56px;
  position: fixed;
  display: flex;
  flex-direction: row;
  top: 50px;
  z-index: 9;
  right: 0px;
  border-radius: 8px 0px 0px 8px;
  // background-image: linear-gradient(to left, #e02020 77%, #ff6a66 0%);
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(77%, #e02020),
    color-stop(0%, #ff6a66)
  );
}

.timerImg {
  position: absolute;
  left: -25px;
  top: -10px;
  height: 100%;
  width: 60%;
}

#timer {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  width: 100%;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  float: left;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
  background-color: rgba(28, 25, 35, 0.5);
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  border: 1px solid #888;
  width: 529px;
  height: 366px;

  border-radius: 12px;
  background-color: #ffffff;

  .header {
    height: 64px;
    border-radius: 8px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 20px 18px 18px 32px;

    .paylief-is-Idle {
      object-fit: contain;
      font-family: Montserrat;
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5d409f;
    }
  }

  .body {
    text-align: center;
    margin-top: 32px;
    .auto-Logout-in {
      font-family: Montserrat;
      font-size: 18px;
      font-weight: 600;
      font-style: normal;
      color: #646464;
    }
  }
  .footer {
    text-align: center;
    margin-top: 39px;
    .all-Unsaved-Informat {
      font-family: Montserrat;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #e24c4b;
    }
  }
}

/** Timer CSS */

$flipColour: #fff;
$flipColourDark: darken($flipColour, 35%);
$textColour: #333;
$textColourDark: darken($textColour, 35%);

html {
  height: 100%;
}

.digit {
  position: relative;
  float: left;
  width: 10vw;
  height: 15vw;
  background-color: $flipColour;
  border-radius: 1vw;
  text-align: center;
  font-family: Oswald, sans-serif;
  font-size: 11vw;
}

.base {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: $textColour;
}

.flap {
  display: none;
  position: absolute;
  width: 100%;
  height: 50%;
  background-color: $flipColour;
  left: 0;
  top: 0;
  // border-radius: 1vw 1vw 0 0;
  border-radius: 8px 8px 0px 0px;
  transform-origin: 50% 100%;
  backface-visibility: hidden;
  overflow: hidden;

  &::before {
    content: attr(data-content);
    position: absolute;
    left: 50%;
  }

  &.front::before,
  &.under::before {
    top: 100%;
    transform: translate(-50%, -50%);
  }

  &.back {
    transform: rotateY(180deg);
    &::before {
      top: 100%;
      transform: translate(-50%, -50%) rotateZ(180deg);
    }
  }

  &.over {
    z-index: 2;
  }

  &.under {
    z-index: 1;
  }

  &.front {
    animation: flip-down-front 300ms ease-in both;
  }

  &.back {
    animation: flip-down-back 300ms ease-in both;
  }

  &.under {
    animation: fade-under 300ms ease-in both;
  }
}

@keyframes flip-down-front {
  0% {
    transform: rotateX(0deg);
    background-color: $flipColour;
    color: $textColour;
  }
  100% {
    transform: rotateX(-180deg);
    background-color: $flipColourDark;
    color: $textColourDark;
  }
}

@keyframes flip-down-back {
  0% {
    transform: rotateY(180deg) rotateX(0deg);
    background-color: $flipColourDark;
    color: $textColourDark;
  }
  100% {
    transform: rotateY(180deg) rotateX(180deg);
    background-color: $flipColour;
    color: $textColour;
  }
}

@keyframes fade-under {
  0% {
    background-color: $flipColourDark;
    color: $textColourDark;
  }
  100% {
    background-color: $flipColour;
    color: $textColour;
  }
}

.clock {
  transform: translateY(-50%);
  perspective: 100vw;
  perspective-origin: 50% 50%;
  margin-top: 70px;

  .digit {
    // margin-right: 1vw;
    margin-right: 6px;
    &:nth-child(2n + 2) {
      // margin-right: 3.5vw;
      margin-right: 20px;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

/** 2nd Flipper */

body {
  background: #222222;
  box-shadow: inset 0 0 400px #111111;
  font-family: "Anton", sans-serif;
  height: 100%;
}

.container {
  height: 200px;
  position: relative;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
}

@for $i from 10 through 1 {
  .nums-one .num:nth-of-type(#{$i}) {
    animation-name: num-one;
    animation-delay: $i - 1s;
    animation-duration: 10s;
    z-index: (10 - $i) + 1;
  }

  .nums-ten .num:nth-of-type(#{$i}) {
    animation-name: num-ten;
    animation-delay: ($i * 10s) - 1s;
    animation-duration: 100s;
    z-index: (10 - $i) + 1;
  }
}

@mixin num-keyframes($name, $time) {
  $per-100: (1 / $time) * 100%;

  @keyframes num-#{$name} {
    0% {
      transform: rotateX(0);
      z-index: 50;
    }
    #{$per-100} {
      transform: rotateX(-180deg);
      z-index: 50;
    }
    90% {
      transform: rotateX(-180deg);
      z-index: 1;
    }
    90.0001% {
      transform: rotateX(0);
    }
    100% {
      transform: rotateX(0);
    }
  }
}

@include num-keyframes("one", 10);
@include num-keyframes("ten", 100);

.timercount {
  background: black;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  width: 150px;
  height: 93px;
  font-family: Avenir;
  font-size: 68px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #616161;

  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in;
  border-radius: 5px;
  left: 0;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
}

.display-flex {
  display: flex;
  justify-content: center;
  margin-top: -20px;
  text-align: center;
  height: 135px;
}

.bottom-text {
  display: flex;
  justify-content: space-evenly;
  margin-top: 5px;
}

.Flip-Top {
  width: 64px;
  height: 96px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border: solid 1.6px #d6d6d6;
  background-image: linear-gradient(to bottom, #f9f9f9, #f6f6f6);
}

// .Flip-Bottom {
//   width: 64px;
//   height: 48px;
//   border-radius: 8px;
//   border-bottom-left-radius: 8px;
//   border-bottom-right-radius: 8px;
//   border-right: solid 1.6px #d6d6d6;
//   border-left: solid 1.6px #d6d6d6;
//   border-bottom: solid 1.6px #d6d6d6;
//   background-color: #ffffff;
// }

.Flip-Bottom {
  width: 64px;
  height: 48px;
  border: 8px;
  border-top: solid 1.6px #d6d6d5;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: solid 1.6px #d6d6d6;
  border-left: solid 1.6px #d6d6d6;
  border-bottom: solid 1.6px #d6d6d6;
  background-color: #ffffff;
  margin-left: -2px;
  margin-top: 46px;
}

.timersNumberStyle {
  font-family: Avenir;
  font-size: 68px;
  font-weight: 900;
  font-style: normal;
  text-align: center;
  color: #616161;
}

.mins-text {
  font-family: Montserrat;
  font-size: 19.2px;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  color: #606060;
  margin-right: -70px;
}
.secs-text {
  font-family: Montserrat;
  font-size: 19.2px;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  color: #606060;
  margin-right: 0px;
}

.imgClass {
  width: 26px;
  height: 24px;
}

.padding-5 {
  padding: 0px 5px 0px 0px;
}
.padding-20 {
  padding: 0px 20px 0px 0px;
}
</style>
